import { observer } from "mobx-react";
import { Container, Row } from "react-bootstrap";
import { MiniConsoleIcons } from "../../../MiniComponents/miniConsoles";
import React, { CSSProperties } from "react";
import Trophy from "../../../Assets/Icons/trophy.png";
import RevenueIcon from "../../../Assets/Icons/banknote.png";
import { authStore } from "../../../App";

const _Dashboard: React.FC = () => {
  return (
    <Container>
      <Row>
        <Container
          style={{
            width: "50%",
            background: "gold",
            display: "flex",
            flexFlow: "column",
            padding: "50px",
          }}
        >
          <label style={{ textDecoration: "underline" }}>
            Store Management
          </label>
          <h1 style={{ fontSize: "80px", fontWeight: "bolder" }}>
            Store: {authStore.focusedStore?.storeName}
          </h1>
          <label>
            With Only Ryan Business you keep are in full control of your
            consoles, controllers, <MiniConsoleIcons />
          </label>
        </Container>
        <Container style={{ background: "transparent", width: "50%" }}>
          <img
            src="https://www.notion.com/_next/image?url=%2Ffront-static%2Fpages%2Fprojects%2Fhero.png&w=640&q=75"
            width={"100%"}
            style={{ padding: "50px" }}
          />
        </Container>
      </Row>
      <Row>
        <SumCard iconUrl={RevenueIcon} title="Revenue" width={"25%"} />
        <SumCard iconUrl={Trophy} title="Tournaments" width={"25%"} />
        <SumCard iconUrl={Trophy} title="Competitors" width={"25%"} />
        <SumCard iconUrl={Trophy} title="Revenue" width={"25%"} />
      </Row>
    </Container>
  );
};

const _SumCard: React.FC<{
  width: string | number;
  iconUrl: string;
  title: string;
}> = ({ width, title, iconUrl }) => {
  return (
    <div
      style={{
        width: width,
        display: "flex",
        flexFlow: "column",
        textAlign: "center",
        padding: 25,
      }}
    >
      <img src={iconUrl} width={50} style={{ margin: "0px auto" }} />
      <h1 style={{ fontWeight: "bolder" }}>{title}</h1>
    </div>
  );
};

const SumCard = observer(_SumCard);

const Dashboard = observer(_Dashboard);

export { Dashboard };
